import React from 'react';
import { getTheme, mergeStyles } from '@fluentui/react';

const CallActionBarDivider: React.FC<{ vertical?: boolean }> = ({ vertical }) => {
    const theme = getTheme();
    return (
        <div
            className={mergeStyles({
                backgroundColor: theme.palette.neutralQuaternary,
                ...(vertical ? { height: 1, width: '100%' } : { height: '100%', width: 1 })
            })}
        />
    );
};

export default CallActionBarDivider;
